import { render, staticRenderFns } from "./EdgeGateway.vue?vue&type=template&id=313ebce2&scoped=true"
import script from "./EdgeGateway.vue?vue&type=script&lang=js"
export * from "./EdgeGateway.vue?vue&type=script&lang=js"
import style0 from "./EdgeGateway.vue?vue&type=style&index=0&id=313ebce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ebce2",
  null
  
)

export default component.exports